import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const adminGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.ready()) {
    await auth.loadMe();
  }
  if (String(auth.user()?.role ?? '').toLowerCase() === 'admin') {
    return true;
  }
  await router.navigateByUrl('/reservations');
  return false;
};
